// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer_footer__PMQDi","terms":"footer_terms__0hwvX","text":"footer_text__kHQ77"};